module.exports = __webpack_public_path__ + "img/play-circle.74644741.svg";